import { inject, injectable } from "@launchtray/tsyringe-async";
import { BaseAnalyticEvent } from "./events/BaseAnalyticEvent";
import { GameInfo } from "./GameInfo";
import { IAnalyticsProvider } from "./IAnalyticsProvider";
import { FacebookAnalyticsProvider } from "./FacebookAnalyticsProvider";
import { GoogleAnalyticsProvider } from "./GoogleAnalyticsProvider";
import { IAnalyticProviderWrapper } from "./IAnalyticProviderWrapper";
import { AnalyticEventType } from "./events/AnalyticEventType";
import { VirtualScreenEvent } from "./events/VirtualScreenEvent";
import { ILogger } from "../cityversetycoon/logger/ILogger";
import { VariableSaver } from "../tools/variableSaver/VariableSaver";

@injectable()
export class AnalyticsProvider implements IAnalyticProviderWrapper {
    private readonly facebookAnalyticsProvider: IAnalyticsProvider;
    private readonly googleAnalyticsProvider: IAnalyticsProvider;
    private readonly analyticProviders: Array<IAnalyticsProvider>;
    private index: number;
    get currentEventIndex(): number {
        return this.index;
    }

    public constructor(
        gameInfo: GameInfo,
        variableSaver: VariableSaver,
        @inject("ILogger") logger: ILogger
    ) {
        this.googleAnalyticsProvider = new GoogleAnalyticsProvider(gameInfo, variableSaver, logger);
        this.facebookAnalyticsProvider = new FacebookAnalyticsProvider(logger);
        this.analyticProviders = [this.googleAnalyticsProvider, this.facebookAnalyticsProvider];
        this.index = 0;
    }

    public registerEvent(baseEvent: BaseAnalyticEvent): void {
        this.analyticProviders.forEach(analyticsProvider => analyticsProvider?.registerEvent(baseEvent));
    }

    public registerGoogleEvent(baseEvent: BaseAnalyticEvent): void {
        this.googleAnalyticsProvider.registerEvent(baseEvent);
        if (baseEvent.eventType === AnalyticEventType.VirtualScreenView) {
            const event = baseEvent as VirtualScreenEvent;
            this.index = event.screenIndex;
        }
    }

    public registerFbEvent(baseEvent: BaseAnalyticEvent): void {
        this.facebookAnalyticsProvider.registerEvent(baseEvent);
    }
}
